
function initValidateForm() {
  $("#customer_login").validate({
    rules: {
      'customer[email]': {
        required: true,
        email: true,
        maxlength: 100
      },
      'customer[password]': {
        required: true,
        passwordStrength: true,
        minlength: 8,
        maxlength: 32
      }
    },
    messages: {
      'customer[email]': {
        required: "メールアドレスを入力してください。",
        email: "正しいメールアドレスの形式で入力してください。",
        maxlength: "メールアドレスは100文字以内で入力してください。"
      },
      'customer[password]': {
        required: "パスワードを入力してください。",
        passwordStrength: "8〜32文字の半角英数・記号で入力してください。",
        minlength: "パスワードは8文字以上で入力してください。",
        maxlength: "パスワードは32文字以内で入力してください。"
      }
    },
    errorPlacement: function (error, element) {
      error.addClass('c-form__error');
      error.insertAfter(element);
    },
    highlight: function (element) {
      $(element).addClass('c-form__input--error');
    },
    unhighlight: function (element) {
      $(element).removeClass('c-form__input--error');
    }
  });

  $("#customer_login").on("submit", function (e) {
    const $form = $(this);

    if (!$form.valid()) {
      e.preventDefault();
      return false;
    }

    const submitButton = $form.find('button[type="submit"]');
    const originalText = submitButton.find('.c-btn__detail-txt').text();
    submitButton.find('.c-btn__detail-txt').text('送信中...');
    submitButton.prop('disabled', true);

    setTimeout(function () {
      submitButton.find('.c-btn__detail-txt').text(originalText);
      submitButton.prop('disabled', false);
    }, 10000);
  });
}

$.validator.addMethod("passwordStrength", function (value, element) {
  if (this.optional(element)) {
    return true;
  }
  // Must contain at least one letter, one number, and be 8-32 characters
  return /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,32}$/.test(value);
}, "パスワードは半角英数記号を含む8〜32文字で入力してください。");


// Real-time validation feedback
function initRealtimeValidation() {
  // Password strength indicator
  $('#password').on('input', function () {
    const password = $(this).val();
    let strength = 0;

    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/\d/.test(password)) strength++;
    if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;

    // Remove existing strength classes
    $(this).removeClass('c-form__input--weak c-form__input--medium c-form__input--strong');

    if (password.length > 0) {
      if (strength <= 2) {
        $(this).addClass('c-form__input--weak');
      } else if (strength <= 3) {
        $(this).addClass('c-form__input--medium');
      } else {
        $(this).addClass('c-form__input--strong');
      }
    }
  });
}


//------------------------------
$(function () {
  initValidateForm();

  initRealtimeValidation();
});